export default props => ({
    // Default theme
    background: props.theme.brand01,
    disablePrimary: props.theme.disablePrimary,
    easing: props.theme.easing.ease_inOut,
    focus: props.theme.focusPrimary,
    fontFamily: props.theme.font.default,
    fontSize: props.theme.type.type0,
    hover: props.theme.hoverPrimary,
    radius: props.theme.atoms.button.radius,
    spinnerMargin: props.theme.spacingXs,
    text: props.theme.brand02,
    textTransform: 'none',

    // Override with custom theme - this also defines the key under which
    // the theme can be overridden, in this case .automotive.configurationSummary
    // in general should follow the format .<domain>.<componentName>
    ...props.theme?.atoms?.baseButton
  });
